/** A single description for roles on the project level. */

/**
 * Object that determines all different features for users to get
 * access on the project level.
 */

/**
 * Signature for the function hasUserValidFeatureProjectLevel.
 */

/** Names for all features within the project level. */
export let RequiredFeatureProjectLevelName = /*#__PURE__*/function (RequiredFeatureProjectLevelName) {
  /** Whether the user can archive projects. */
  RequiredFeatureProjectLevelName["canArchiveProject"] = "canArchiveProject";
  /** Whether the user can unarchive projects. */
  RequiredFeatureProjectLevelName["canUnarchiveProject"] = "canUnarchiveProject";
  /** Whether the user can view 2d image feature. */
  RequiredFeatureProjectLevelName["canView2dImagesFeature"] = "canView2dImagesFeature";
  /** Whether the user can view video mode feature. */
  RequiredFeatureProjectLevelName["canViewVideoModeFeature"] = "canViewVideoModeFeature";
  /** Whether the user can view face blurring feature. */
  RequiredFeatureProjectLevelName["canViewFaceBlurringFeature"] = "canViewFaceBlurringFeature";
  /** Whether the user can view face blurring feature. */
  RequiredFeatureProjectLevelName["canViewFaceBlurringV1Feature"] = "canViewFaceBlurringV1Feature";
  /** Whether the user can view AI indexing feature. */
  RequiredFeatureProjectLevelName["canViewAiIndexingFeature"] = "canViewAiIndexingFeature";
  /** Whether the user can download projects. */
  RequiredFeatureProjectLevelName["canDownloadProject"] = "canDownloadProject";
  /** Whether the user can manage project integrations. */
  RequiredFeatureProjectLevelName["canManageProjectIntegrations"] = "canManageProjectIntegrations";
  /** Whether the user has permission to export the project data. */
  RequiredFeatureProjectLevelName["canExportProject"] = "canExportProject";
  /** Whether the user can create snapshots. */
  RequiredFeatureProjectLevelName["canCreateSnapshot"] = "canCreateSnapshot";
  /** Whether project members can be assigned a role other than viewer. */
  RequiredFeatureProjectLevelName["canAssignProjectRoles"] = "canAssignProjectRoles";
  return RequiredFeatureProjectLevelName;
}({});